import { IError } from './types'

export const NotFound: IError = {
  code: 'NotFound',
  message: 'Not found',
}